/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@khan/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"mYUqji":["More free content available at ",["url"],"!"],"ye08Fk":["Level 1"],"+8PKcl":["Level 2"],"wOQ/Qw":["Level 3"],"59NJet":["Level 4"],"cHu9Hf":["Level 5 (Mastered)"],"cC6ZmF":["Level 6"],"qVHTsN":["Skill is ",["0"],"!"],"FyOpkw":["Leveled up to ",["0"],"!"],"kku9WO":["Get ",["0"]," of ",["total"]," questions to level up to ",["1"]],"UrKHn4":["Not Started"],"kXdiam":["Attempted"],"IwICMB":["Familiar"],"aWz9oe":["Proficient"],"cLN10o":["Mastered"],"Ef7StM":["Unknown"],"De6VtW":[["pointsEarned"]," energy points"],"yLjl7l":["You earned ",["pointsPart"],"!"],"SrfROI":["Up next"],"qegwP2":["Play the next video"],"1uH6fK":["Replay this video"],"LTnNtk":["Sign in to save your progress"],"7TkjAs":["Play video"],"dnObfd":["Video: ",["title"]],"izuWF0":["Current time:"],"SFES6S":["Total duration:"],"MTfLdZ":["Switch to full player"],"tkDYSE":[["hours","plural",{"one":["#"," hour"],"other":["#"," hours"]}]],"Pfatg8":[["minutes","plural",{"one":["#"," minute"],"other":["#"," minutes"]}]],"iL/HBr":[["seconds","plural",{"one":["#"," second"],"other":["#"," seconds"]}]],"aXu6eY":["Closed Captions"],"NpYAU8":["It looks like your browser doesn't support embedded videos. Don't worry, you can still download it and watch it with your favorite video player!"],"DTXwTE":["Download ",["title"]],"Wy3vms":["Khan Academy video wrapper"]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["zh-hant","sgn-us","is","en-x-rtl","zu","xh","th","sw","fa","ms","he","fa-af","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["ur","te","or","de","lol","id"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
